// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu {
  background-image: url(https://www.zazmic.com/wp-content/themes/zazmic/img/bg.png);
  width: 100%;
  @media screen and (max-width: 600px) {
    display: none;
  } 
}

.dropdown-content {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  position: absolute;
  background-color: #fff;
  flex-direction: column;
  z-index: 1;
  list-style: none;
  padding: 0;
  margin: 0;
  list-style-type: none;
  text-align: left;
  top: 40px;
}

.sub-menu:hover .dropdown-content {
  display: block;

}
.sub-menu li:hover {
  background-color: #f5f5f5;
  
}
.rotate-icon {
  transition: transform 0.3s ease; /* Add a smooth transition effect */
}

.rotate-icon.rotate180 {
  transform: rotate(180deg); /* Rotate the icon 180 degrees */
}
#dropdown-menu::marker {
  display: none;
}
ul,
ol {
  list-style-type: none;
}
.dropdown-toggle {
  color: #1e1c1a !important;
  font-size: 17px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 30px;

  position: relative;
  padding: 5px 0;
  display: flex;
  align-items: center;
}
#svg__icon {
  display: flex;
  margin-left: 10px;
  margin-top: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Menu/Menu.css"],"names":[],"mappings":"AAAA;EACE,iFAAiF;EACjF,WAAW;EACX;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,qBAAqB;EACrB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;;AAEhB;AACA;EACE,yBAAyB;;AAE3B;AACA;EACE,+BAA+B,EAAE,mCAAmC;AACtE;;AAEA;EACE,yBAAyB,EAAE,gCAAgC;AAC7D;AACA;EACE,aAAa;AACf;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;;EAEjB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":[".menu {\n  background-image: url(https://www.zazmic.com/wp-content/themes/zazmic/img/bg.png);\n  width: 100%;\n  @media screen and (max-width: 600px) {\n    display: none;\n  } \n}\n\n.dropdown-content {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  position: absolute;\n  background-color: #fff;\n  flex-direction: column;\n  z-index: 1;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  list-style-type: none;\n  text-align: left;\n  top: 40px;\n}\n\n.sub-menu:hover .dropdown-content {\n  display: block;\n\n}\n.sub-menu li:hover {\n  background-color: #f5f5f5;\n  \n}\n.rotate-icon {\n  transition: transform 0.3s ease; /* Add a smooth transition effect */\n}\n\n.rotate-icon.rotate180 {\n  transform: rotate(180deg); /* Rotate the icon 180 degrees */\n}\n#dropdown-menu::marker {\n  display: none;\n}\nul,\nol {\n  list-style-type: none;\n}\n.dropdown-toggle {\n  color: #1e1c1a !important;\n  font-size: 17px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 30px;\n\n  position: relative;\n  padding: 5px 0;\n  display: flex;\n  align-items: center;\n}\n#svg__icon {\n  display: flex;\n  margin-left: 10px;\n  margin-top: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
